import React, { useCallback } from "react"
import PropTypes from "prop-types"

import { ProgressModal } from "@components/Page"
import { ListAllProjectsOutputShape } from "@api/services/backstage"

import ReportFiltersForm from "../ReportFiltersForm"
import useInvestmentsReport from "./helpers/useInvestmentsReport"

const LABEL_TITLE = "Investments Report"


const InvestmentsReportModal = ({ modal, projects = [] }) => {
  const onReady = () => modal.current.close()

  const [ percent, start, stop, reset ] = useInvestmentsReport(onReady)

  const renderFilters = useCallback(() =>
    <ReportFiltersForm
      onSubmit={start}
      projects={projects}
    />
  , [ start, projects ])

  const modalProps = {
    title: LABEL_TITLE,
    stop,
    reset,
    modal,
    start,
    percent,
    renderFilters,
  }

  return (
    <ProgressModal {...modalProps} />
  )
}

InvestmentsReportModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  projects: PropTypes.arrayOf(ListAllProjectsOutputShape),
}

export default InvestmentsReportModal
